import { render } from "./FakeLogicEditorCmp.vue?vue&type=template&id=c2f86cb0"
import script from "./FakeLogicEditorCmp.vue?vue&type=script&lang=js"
export * from "./FakeLogicEditorCmp.vue?vue&type=script&lang=js"

import "./FakeLogicEditorCmp.vue?vue&type=style&index=0&id=c2f86cb0&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__